import { convertIGuideHtmlToLatex } from '../ast/util.html-to-latex.js';
import { convertHeadingToLatex } from './atom.heading.js';
import { convertTaskToLatex } from './atom.task.js';

const linebreak = convertIGuideHtmlToLatex("<br />");
function convertIGuideToLatex(component, entry, args) {
  const heading = convertHeadingToLatex(component, args.backlink);
  const includeHeadingInTask = component.data.tasks.length > 1;
  const tasks = component.data.tasks.map((task, index) => convertTaskToLatex(task, entry, {
    taskIndex: index,
    includeHeading: includeHeadingInTask
  })).join(linebreak);
  return `${heading}${tasks}`;
}

export { convertIGuideToLatex };
//# sourceMappingURL=_print.word.js.map
